// extracted by mini-css-extract-plugin
module.exports = {"iconEffect":"iU","iconInPlayer":"iV"};